import {
  SET_CHOSEN_PLAN,
  FETCH_ALL_PLANS,
} from './../../mutation-types';

export default {
  [SET_CHOSEN_PLAN](state, plan) {
    state.chosenPlan = plan;
  },

  [FETCH_ALL_PLANS](state, plans) {
    state.plans = plans;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/plan/mutations.js